// extracted by css-extract-rspack-plugin
module.exports =  {"money":"MoneyCell__money___z3HIJ","moneyInput":"MoneyCell__moneyInput___zIv6x"};